export default "/images/b816c74bb960310fa92436a910305bea.avif";